import React, { useEffect } from 'react'
import styled from 'styled-components'
import GameCommunicatorService from 'common/Services/GameCommunicatorService'
import { StyledIframe } from 'features/GameArea/styled'
import GamesService from 'common/Services/GamesService'
import UserService from 'common/Services/UserService'
import { ModalService } from 'common/Services/ModalService'

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    background: black;
`

const GameModal = ({ data }) => {
    const { link } = data

    const goBack = () => {
        UserService.setIsUserLoggedIn()
        window.location.href = '/'
    }

    const onLoadGame = (e) => {
        GameCommunicatorService.init(e.target, link)

        GameCommunicatorService.postMessage({
            messageType: 'addEventListener',
            eventType: 'backToLobby',
        })

        GameCommunicatorService.onGameExit = () => {
            GamesService.getEndGame()
            goBack()
        }
    }

    useEffect(() => {
        const handlePopState = () => {
            ModalService.closeModal('GAME_MODAL')
        }

        window.addEventListener('popstate', handlePopState)

        return () => {
            window.removeEventListener('popstate', handlePopState)
        }
    }, [])

    return (
        <Wrapper>
            <StyledIframe src={link} onLoad={onLoadGame} name="gameIframe" />
        </Wrapper>
    )
}
export default GameModal
